import React from "react";
import { Fragment } from "react";
import { Modal } from "react-bootstrap";
// import "../styles/MySchedule.scss";

const InstructionModal = ({okayClickHandler }) => {
  return (
    <Fragment>
        <div className="myschedule-modal">
        <div className="d-flex justify-content-between pb-2">
            <b>Instructions</b>
            <button
              className=" border-0 bg-white text-right pr-3"
              onClick={okayClickHandler}
            >
              Close <span style={{ fontSize: "15px" }}>X</span>{" "}
            </button>
          </div>

          <div className=" align-items-center instructions-wrapper">
            <div className={["p-2", "instructions-div"].join(" ")}>
              <ul className="list">
                <li className="list-item">
                  Select duration and fees for both your regular and follow-up
                  appointments under Consultation Settings.To make follow-ups
                  free, insert fees as zero. Click on Save.
                </li>

                <li className="list-item">
                  Under Set Up Your Availability, add your availability for each
                  day of the week, in as many time-blocks or slots as needed.Do
                  remember to save your selected slots for each day before
                  moving to the next day.
                </li>

                <li className="list-item">
                  Select "Copy slots to other days"before clicking on Save to
                  copy your slots for one day to the other days of the week.
                </li>
              </ul>
            </div>
            <div className="text-center ">
              <button className="btn primary-cta-button rounded-pill py-2 px-2 mt-3" onClick={okayClickHandler}>
                Okay
              </button>
            </div>
          </div>
     </div>
    </Fragment>
  );
};

export default InstructionModal;
